import { Injectable } from '@angular/core'
import { AngularFireDatabase } from 'angularfire2/database'

import { Observable } from 'rxjs/Observable'

import * as firebase from 'firebase'

@Injectable()
export class CreditService {

  private readonly firebaseRef = firebase.database().ref('test')

  private readonly bonusTable = {
    'finished_profile': 10,
    'first_login': 10,
    'out_of_credits': 0
  }

  constructor(private db: AngularFireDatabase) { }

  public addCredits(uid: string, number: number): Promise<any> {
    return this.setCreditsToDatabase(uid, number)
  }

  public addCreditsFromBonus(uid: string, name: string): Promise<boolean> {
    return this.checkIfBonusIsDone(uid, name)
      .then((timestamp: number) => {
        if (timestamp === null) {
          const number = this.bonusTable[name] || 0
          return this.setCreditsToDatabase(uid, number)
            .then(() => {
              return this.setBonusAsDone(uid, name)
            })
            .then(() => {
              return true
            })
        } else {
          return false
        }
      })
  }

  public consumeCredit(uid: string): Promise<any> {

    return this.checkIfUserSubcribed(uid)
      .then((isSubscribed: boolean) => {
        if (!isSubscribed) {
          return this.setCreditsToDatabase(uid, -1)
            .then((credits: number) => {
              if (credits === 0) {
                this.addCreditsFromBonus(uid, 'out_of_credits')
              }
            })
        }
      })
  }

  public getCreditCount(uid: string): Observable<number> {
    const creditsRef = this.firebaseRef.child(`users/${uid}/credits`)
    return this.db.object(creditsRef)
      .map((item: any) => {
        return item.$value
      })
  }

  private checkIfBonusIsDone(uid: string, name: string): Promise<number> {
    return <Promise<any>>this.firebaseRef.child(`bonusCredits/${uid}/${name}`).once('value')
      .then((snapshot: firebase.database.DataSnapshot) => {
        return snapshot.val()
      })
  }

  private setBonusAsDone(uid: string, name: string): Promise<any> {
    return <Promise<any>>this.firebaseRef
      .child(`bonusCredits/${uid}/${name}`)
      .set(firebase.database.ServerValue.TIMESTAMP)
  }

  private setCreditsToDatabase(uid: string, number: number): Promise<number> {
    let newCreditsAmount = 0
    return this.getCreditCount(uid)
      .first()
      .toPromise()
      .then((credits: number) => {
        const newCreditsAmount = credits + number
        return this.firebaseRef.child(`users/${uid}/credits`).set(newCreditsAmount)
      })
      .then(() => {
        return newCreditsAmount
      })
  }

  private checkIfUserSubcribed(uid: string): Promise<boolean> {
    return this.firebaseRef.child(`users/${uid}/subExpiryDate`).once('value')
      .then((snapshot: firebase.database.DataSnapshot) => {
        const subExpirationDate = snapshot.val()
        return subExpirationDate && subExpirationDate >= (+new Date())
      }) as Promise<boolean>
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/consumables/shared/credit.service.ts